import React, { useEffect, useState } from "react";
import "../../UserSetting/toggle-css.css";
import styles from "../settings.module.css";
import { Form } from "react-bootstrap";
import Select from "../../../../../components/CustomSelect/Select";
import { useDispatch, useSelector } from "react-redux";
import { editNotificationSettings } from "../../../../../general_redux/general settings/actions";

const options = [
  { value: "app_and_email", label: "In-app and email" },
  { value: "in_app", label: "In-app only" },
  { value: "email", label: "Email only" },
  { value: "opt_out", label: "Do not notify" },
];

function SettingsNotification() {
  const dispatch = useDispatch();
  const { setting } = useSelector(
    ({ generalSetting }) => generalSetting && generalSetting
  );

  const [defaultNewReservation, setDefaultNewReservation] = useState(
    setting &&
      options.find((option) => option.value === setting.newReservationNotif)
      ? options.find((option) => option.value === setting.newReservationNotif)
      : options[0]
  );
  const [defaultReservationModification, setDefaultReservationModification] =
    useState(
      setting &&
        options.find(
          (option) => option.value === setting.reservationModificationNotif
        )
        ? options.find(
            (option) => option.value === setting.reservationModificationNotif
          )
        : options[0]
    );
  const [defaultReservationCancellation, setDefaultReservationCancellation] =
    useState(
      setting &&
        options.find(
          (option) => option.value === setting.reservationCancellationNotif
        )
        ? options.find(
            (option) => option.value === setting.reservationCancellationNotif
          )
        : options[0]
    );
  const [defaultReservationRequest, setDefaultReservationRequest] = useState(
    setting &&
      options.find((option) => option.value === setting.reservationRequestNotif)
      ? options.find(
          (option) => option.value === setting.reservationRequestNotif
        )
      : options[0]
  );
  const [defaultNotifyNewFeature, setDefaultNotifyNewFeature] = useState(
    setting &&
      options.find((option) => option.value === setting.newFeatureNotif)
      ? options.find((option) => option.value === setting.newFeatureNotif)
      : options[0]
  );

  const handleSave = (e) => {
    e.preventDefault();
    const data = {
      notificationSettings: {
        newReservationNotif: defaultNewReservation.value,
        reservationModificationNotif: defaultReservationModification.value,
        reservationCancellationNotif: defaultReservationCancellation.value,
        reservationRequestNotif: defaultReservationRequest.value,
        newFeatureNotif: defaultNotifyNewFeature.value,
      },
    };
    dispatch(editNotificationSettings(data));
  };

  return (
    <div mt-1>
      <div
        style={{ display: "flex", flexDirection: "column" }}
        className="pb-2"
      >
        <h2 className={styles.settings__header}>Notification Settings</h2>
        <div style={{ marginLeft: "8px" }}>
          You can control if and how you would like to be notified of channel
          reservation events (if you are connected to at least one channel).
          Choose bellow if you would like to receive an email notification, if
          you want the notification to be seen only in your Beehaz account
          (in-app), or if you do not want to see notifications for certain
          events at all.
        </div>
        <div style={{ marginLeft: "8px", marginTop: "20px" }}>
          Note: you will still be able to see such events under the ‘Activity’
          tab in the ‘Notifications’ page.
        </div>
        <Form
          onSubmit={handleSave}
          className={styles.settings_wrapper}
          autoComplete="off"
        >
          <div className={`input-group mb-3 ${styles.input_group}`}>
            <div className="input-group-prepend">
              <label
                className={`input-group-text ${styles.input_group_text}`}
                htmlFor="propertyType"
              >
                New reservations:
              </label>
            </div>

            <Select
              options={options}
              value={defaultNewReservation}
              onChange={(val) => setDefaultNewReservation(val)}
              className={`custom-select ${styles.form_entry}`}
            />
          </div>
          <div className={`input-group mb-3 ${styles.input_group}`}>
            <div className="input-group-prepend">
              <label
                className={`input-group-text ${styles.input_group_text}`}
                htmlFor="propertyType"
              >
                Reservation modifications:
              </label>
            </div>

            <Select
              options={options}
              value={defaultReservationModification}
              onChange={(val) => setDefaultReservationModification(val)}
              className={`custom-select ${styles.form_entry}`}
            />
          </div>
          <div className={`input-group mb-3 ${styles.input_group}`}>
            <div className="input-group-prepend">
              <label
                className={`input-group-text ${styles.input_group_text}`}
                htmlFor="propertyType"
              >
                Reservation cancellations:
              </label>
            </div>

            <Select
              options={options}
              value={defaultReservationCancellation}
              onChange={(val) => setDefaultReservationCancellation(val)}
              className={`custom-select ${styles.form_entry}`}
            />
          </div>
          <div className={`input-group mb-3 ${styles.input_group}`}>
            <div className="input-group-prepend">
              <label
                className={`input-group-text ${styles.input_group_text}`}
                htmlFor="propertyType"
              >
                Reservation requests:
              </label>
            </div>

            <Select
              options={options}
              value={defaultReservationRequest}
              onChange={(val) => setDefaultReservationRequest(val)}
              className={`custom-select ${styles.form_entry}`}
            />
          </div>
          <div
            style={{ marginLeft: "8px", marginTop: "20px" }}
          >
            Would you like to receive Beehaz features updates?
          </div>
          <div
            style={{ marginTop: "16px" }}
            className={`input-group mb-3 ${styles.input_group}`}
          >
            <div className="input-group-prepend">
              <label
                className={`input-group-text ${styles.input_group_text}`}
                htmlFor="propertyType"
              >
                Notify about new features:
              </label>
            </div>

            <Select
              options={options}
              value={defaultNotifyNewFeature}
              onChange={(val) => setDefaultNotifyNewFeature(val)}
              className={`custom-select ${styles.form_entry}`}
            />
          </div>

          <div className="d-flex justify-content-start">
            <button className={styles.settings_save} type="submit">
              Save Changes
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default SettingsNotification;
